export function createContextHMR(createContext, key) {
	if (import.meta.hot?.data?.[key]) return import.meta.hot.data[key];
	const ctx = createContext();
	if (import.meta.hot) import.meta.hot.data[key] = ctx;
	return ctx;
}
